import React from 'react';
import { StoryblokImageType } from '../../types'

export type StoryblokImageProps = {
  image?: StoryblokImageType,
  className?: string,
}

const StoryblokImage = ({ image, className }: StoryblokImageProps) => {

  if (!image || !image.filename) {
    return null;
  }

  return (
    <img
      className={className}
      src={image.filename}
      alt={image.alt}
    />
  )
};

export default StoryblokImage;
